import { actionConst } from '../constants/expired-requests.constants';

const defaultState = { count: 0, fetchIds: new Set() };

const executorForSet = ({ set, method, value }) => {
  set[method](value);
  return new Set(set);
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actionConst.COUNT_PENDING: {
      const fetchIds = executorForSet({
        set: state.fetchIds,
        method: 'add',
        value: action.payload,
      });

      return { ...state, fetchIds };
    }

    case actionConst.COUNT_REJECTED: {
      const { isCancel, fetchId } = action.payload;

      const fetchIds = executorForSet({
        set: state.fetchIds,
        method: 'delete',
        value: fetchId,
      });

      return { ...state, fetchIds, count: isCancel ? state.count : 0 };
    }

    case actionConst.COUNT_FULFILLED: {
      const { data, fetchId } = action.payload;

      const fetchIds = executorForSet({
        set: state.fetchIds,
        method: 'delete',
        value: fetchId,
      });

      return { ...state, count: data, fetchIds };
    }

    default:
      return state;
  }
};
